/** DOM adapter for the same Hugeicons data used by the React design system. `strokeWidth` defaults to the action
 * glyph's 2; the modal-title glyph passes MODAL_GLYPH_PROPS' 1.5. */
export function createIcon(doc, icon, name, strokeWidth = '2') {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = doc.createElementNS(ns, 'svg');
    for (const [key, value] of Object.entries({ width: '16', height: '16', viewBox: '0 0 24 24', fill: 'none', color: 'currentColor', 'aria-hidden': 'true', 'data-toolbar-icon': name }))
        svg.setAttribute(key, value);
    for (const [tag, attributes] of icon) {
        const node = doc.createElementNS(ns, tag);
        for (const [key, value] of Object.entries(attributes)) {
            if (key === 'key')
                continue;
            node.setAttribute(key.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`), key === 'strokeWidth' ? strokeWidth : String(value));
        }
        svg.append(node);
    }
    return svg;
}
//# sourceMappingURL=iconDom.js.map